import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { userService, transactionService } from "../../../services";
import Spinner from "../../../components/UI/Spinner";
import ErrorModal from "../../../components/UI/Error";

const UserPersonalInfo = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState({});
  const [userData, setUserData] = useState(null);
  const { id } = useParams();

  useEffect(() => {
    const fetchUser = async () => {
      try {
        let user = await userService.myProfile(id);
        if (user.hasSubscription) {
          const subscriptionStatus = await transactionService.mySubStatus(id);
          user = { ...user, planName: subscriptionStatus?.planType || "NA" };
        }
        setUserData(user);
      } catch (error) {
        setError(true);
        setErrorMessage({ title: "Fetching", message: "fetch" });
        console.error("Failed to fetch user data", error);
      } finally {
        setLoading(false);
      }
    };
    fetchUser();
  }, [id]);

  if (loading)
    return (
      <div className="grid place-content-center h-[60vh]">
        <Spinner />
      </div>
    );

  if (error)
    return (
      <ErrorModal
        isOpen={error}
        onClose={() => setError(false)}
        title={`Error ${errorMessage?.title || "Fetching"} User`}
        message={`There is error while trying to ${
          errorMessage?.message || "fetch"
        } the user details. Please check your internet connectivity and refresh this page to try again.`}
      />
    );
  const handleFreePlan = async () => {
    try {
      const serviceType =
        userData?.hasSubscription && userData?.planName === "Free Plan"
          ? "revoke"
          : "initiate";
      let response;
      if (serviceType === "initiate") {
        response = await transactionService.switchUserToFreePlan(id);
        if (response.success) {
          setUserData((prev) => ({
            ...prev,
            hasSubscription: true,
            planName: "Free Plan",
          }));
        }
      } else {
        response = await transactionService.removeUserFromFreePlan(id);
        if (response.success) {
          setUserData((prev) => ({
            ...prev,
            hasSubscription: false,
            planName: null,
          }));
        }
      }
    } catch (error) {
      setError(true);
      setErrorMessage({ title: "Updating", message: "update" });
      console.error("Failed to update user data", error);
    } finally {
      setLoading(false);
    }
  };
  const { username, stageName, email, bio, hasSubscription, planName } =
    userData || {};
  console.log(planName);
  return (
    <div className="max-w-xl mx-auto bg-white shadow-sm border border-gray-200 rounded-md p-4 mt-6 text-sm text-gray-700">
      {/* Username Centered and Prominent */}
      <div className="text-center mb-6">
        <h1 className="text-2xl font-bold capitalize text-gray-800">
          {username || "-"}
        </h1>
        <p className="text-gray-500 text-sm"> Profile</p>
      </div>

      {/* 2-column Grid for Personal Info */}
      <div className="grid grid-cols-1 capitalize sm:grid-cols-2 gap-4">
        <div>
          <p className="text-gray-500 font-medium mb-0.5">Stage Name</p>
          <p className="text-gray-800">{stageName || "-"}</p>
        </div>
        <div>
          <p className="text-gray-500  font-medium mb-0.5">Stage Name</p>
          <p className="text-gray-800 lowercase">{email || "-"}</p>
        </div>
      </div>

      {/* Bio */}
      {bio && (
        <div className="mt-5">
          <p className="text-gray-500 font-medium mb-0.5">Bio</p>
          <p className="text-gray-800 bg-gray-50 rounded p-3 border leading-snug">
            {bio}
          </p>
        </div>
      )}

      {/* Plan Type Row */}
      <div className="flex flex-wrap sm:flex-nowrap items-center mt-4 gap-4">
        <div className="w-full sm:w-[40%]">
          <p className="text-gray-500 font-medium mb-0.5">Subscription Type</p>
        </div>
        <div className="w-full sm:w-[30%]">
          <p className="text-gray-800">
            {hasSubscription && planName ? planName : "Inactive"}
          </p>
        </div>
        <button
          className="w-full sm:w-auto bg-gray-600 hover:bg-gray-700 text-white text-xs px-4 py-2 rounded shadow-sm transition whitespace-nowrap self-end"
          onClick={handleFreePlan}>
          {hasSubscription && planName === "Free Plan"
            ? "Revoke Free Plan"
            : "Make Free Plan"}
        </button>
      </div>
    </div>
  );
};

export default UserPersonalInfo;
